/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateInvoiceCompanyDto } from '../models';
// @ts-ignore
import type { InvoiceCompanyResponseDto } from '../models';
// @ts-ignore
import type { UpdateInvoiceCompanyDto } from '../models';
/**
 * InvoiceCompaniesApi - axios parameter creator
 * @export
 */
export const InvoiceCompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new invoice company
         * @param {CreateInvoiceCompanyDto} createInvoiceCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceCompany: async (createInvoiceCompanyDto: CreateInvoiceCompanyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvoiceCompanyDto' is not null or undefined
            assertParamExists('createInvoiceCompany', 'createInvoiceCompanyDto', createInvoiceCompanyDto)
            const localVarPath = `/api/v1/invoice-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an invoice company
         * @param {string} id 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvoiceCompany: async (id: string, businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteInvoiceCompany', 'id', id)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('deleteInvoiceCompany', 'businessId', businessId)
            const localVarPath = `/api/v1/invoice-companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all invoice companies for a business
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceCompanies: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('getInvoiceCompanies', 'businessId', businessId)
            const localVarPath = `/api/v1/invoice-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single invoice company by ID
         * @param {string} id 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceCompanyById: async (id: string, businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoiceCompanyById', 'id', id)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('getInvoiceCompanyById', 'businessId', businessId)
            const localVarPath = `/api/v1/invoice-companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search invoice companies
         * @param {number} businessId 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchInvoiceCompanies: async (businessId: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('searchInvoiceCompanies', 'businessId', businessId)
            const localVarPath = `/api/v1/invoice-companies/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an invoice company
         * @param {string} id 
         * @param {number} businessId 
         * @param {UpdateInvoiceCompanyDto} updateInvoiceCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceCompany: async (id: string, businessId: number, updateInvoiceCompanyDto: UpdateInvoiceCompanyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateInvoiceCompany', 'id', id)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('updateInvoiceCompany', 'businessId', businessId)
            // verify required parameter 'updateInvoiceCompanyDto' is not null or undefined
            assertParamExists('updateInvoiceCompany', 'updateInvoiceCompanyDto', updateInvoiceCompanyDto)
            const localVarPath = `/api/v1/invoice-companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessId !== undefined) {
                localVarQueryParameter['businessId'] = businessId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvoiceCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceCompaniesApi - functional programming interface
 * @export
 */
export const InvoiceCompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceCompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new invoice company
         * @param {CreateInvoiceCompanyDto} createInvoiceCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoiceCompany(createInvoiceCompanyDto: CreateInvoiceCompanyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceCompanyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoiceCompany(createInvoiceCompanyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceCompaniesApi.createInvoiceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an invoice company
         * @param {string} id 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvoiceCompany(id: string, businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvoiceCompany(id, businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceCompaniesApi.deleteInvoiceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all invoice companies for a business
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceCompanies(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceCompanyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceCompanies(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceCompaniesApi.getInvoiceCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single invoice company by ID
         * @param {string} id 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceCompanyById(id: string, businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceCompanyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceCompanyById(id, businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceCompaniesApi.getInvoiceCompanyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search invoice companies
         * @param {number} businessId 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchInvoiceCompanies(businessId: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceCompanyResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchInvoiceCompanies(businessId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceCompaniesApi.searchInvoiceCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an invoice company
         * @param {string} id 
         * @param {number} businessId 
         * @param {UpdateInvoiceCompanyDto} updateInvoiceCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInvoiceCompany(id: string, businessId: number, updateInvoiceCompanyDto: UpdateInvoiceCompanyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceCompanyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvoiceCompany(id, businessId, updateInvoiceCompanyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceCompaniesApi.updateInvoiceCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceCompaniesApi - factory interface
 * @export
 */
export const InvoiceCompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceCompaniesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new invoice company
         * @param {CreateInvoiceCompanyDto} createInvoiceCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceCompany(createInvoiceCompanyDto: CreateInvoiceCompanyDto, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceCompanyResponseDto> {
            return localVarFp.createInvoiceCompany(createInvoiceCompanyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an invoice company
         * @param {string} id 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvoiceCompany(id: string, businessId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInvoiceCompany(id, businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all invoice companies for a business
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceCompanies(businessId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceCompanyResponseDto>> {
            return localVarFp.getInvoiceCompanies(businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single invoice company by ID
         * @param {string} id 
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceCompanyById(id: string, businessId: number, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceCompanyResponseDto> {
            return localVarFp.getInvoiceCompanyById(id, businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search invoice companies
         * @param {number} businessId 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchInvoiceCompanies(businessId: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceCompanyResponseDto>> {
            return localVarFp.searchInvoiceCompanies(businessId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an invoice company
         * @param {string} id 
         * @param {number} businessId 
         * @param {UpdateInvoiceCompanyDto} updateInvoiceCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceCompany(id: string, businessId: number, updateInvoiceCompanyDto: UpdateInvoiceCompanyDto, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceCompanyResponseDto> {
            return localVarFp.updateInvoiceCompany(id, businessId, updateInvoiceCompanyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceCompaniesApi - object-oriented interface
 * @export
 * @class InvoiceCompaniesApi
 * @extends {BaseAPI}
 */
export class InvoiceCompaniesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new invoice company
     * @param {CreateInvoiceCompanyDto} createInvoiceCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceCompaniesApi
     */
    public createInvoiceCompany(createInvoiceCompanyDto: CreateInvoiceCompanyDto, options?: RawAxiosRequestConfig) {
        return InvoiceCompaniesApiFp(this.configuration).createInvoiceCompany(createInvoiceCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an invoice company
     * @param {string} id 
     * @param {number} businessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceCompaniesApi
     */
    public deleteInvoiceCompany(id: string, businessId: number, options?: RawAxiosRequestConfig) {
        return InvoiceCompaniesApiFp(this.configuration).deleteInvoiceCompany(id, businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all invoice companies for a business
     * @param {number} businessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceCompaniesApi
     */
    public getInvoiceCompanies(businessId: number, options?: RawAxiosRequestConfig) {
        return InvoiceCompaniesApiFp(this.configuration).getInvoiceCompanies(businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single invoice company by ID
     * @param {string} id 
     * @param {number} businessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceCompaniesApi
     */
    public getInvoiceCompanyById(id: string, businessId: number, options?: RawAxiosRequestConfig) {
        return InvoiceCompaniesApiFp(this.configuration).getInvoiceCompanyById(id, businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search invoice companies
     * @param {number} businessId 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceCompaniesApi
     */
    public searchInvoiceCompanies(businessId: number, search?: string, options?: RawAxiosRequestConfig) {
        return InvoiceCompaniesApiFp(this.configuration).searchInvoiceCompanies(businessId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an invoice company
     * @param {string} id 
     * @param {number} businessId 
     * @param {UpdateInvoiceCompanyDto} updateInvoiceCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceCompaniesApi
     */
    public updateInvoiceCompany(id: string, businessId: number, updateInvoiceCompanyDto: UpdateInvoiceCompanyDto, options?: RawAxiosRequestConfig) {
        return InvoiceCompaniesApiFp(this.configuration).updateInvoiceCompany(id, businessId, updateInvoiceCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

